export const breadcrumbsSettings = Object.freeze({
  cutSectionsMaxSize: '100px',
})
